<template>
  <div class="grid bg-white">
    <div class="grid-title">
      <h4 class="heading semi-bold">All Orders</h4>
    </div>
    <div class="grid-body">
      <div class="row">
        <div class="col-md-3">
          <div class="input-group transparent">
            <span class="input-group-addon">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              class="form-control search-fabric"
              @keyup.enter="searchOrder()"
              v-model="searchTerm"
              placeholder="Search Orders"
            />
          </div>
        </div>
        <div class="col-md-4 text-left">
          <div class="mt-10">
            <p-radio
              class="p-default p-curve"
              color="danger"
              name="currency"
              v-model="defaultCurrency"
              :value="null"
              >DEFAULT</p-radio
            >
            <p-radio
              class="p-default p-curve"
              color="danger"
              name="currency"
              v-model="defaultCurrency"
              value="USD"
              >USD</p-radio
            >
            <p-radio
              class="p-default p-curve"
              color="danger"
              name="currency"
              v-model="defaultCurrency"
              value="THB"
              >THB</p-radio
            >
            <p-radio
              class="p-default p-curve"
              color="danger"
              name="currency"
              v-model="defaultCurrency"
              value="EUR"
              >EUR</p-radio
            >
          </div>
        </div>
        <div class="col-md-5 text-right">
          <router-link
            :to="{ name: 'fabric_order_create', params: { type: 'new' } }"
            class="btn shadow btn-primary"
            v-if="!isReadOnlyUser"
          >
            <i class="fa fa-plus-circle" aria-hidden="true"></i> Create New
            Order
          </router-link>
        </div>
      </div>

      <div class="row mt-20">
        <div class="col-md-12">
          <div class="table-responsive">
            <vue-good-table
              mode="remote"
              @on-column-filter="onColumnFilter"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              :pagination-options="{
                enabled: true,
                mode: 'pages',
              }"
              styleClass="table table-striped"
              :rows="rows"
              :columns="columns"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action_id'">
                  <div class="dropdown" v-if="!isReadOnlyUser">
                    <button
                      class="btn btn-default dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <router-link
                          :to="{
                            name: 'fabric_order_update',
                            params: { order_id: props.row.id },
                          }"
                          >Update Order</router-link
                        >
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'fabric_order_delivery_create',
                            params: { order_id: props.row.id },
                          }"
                          >Add Delivery</router-link
                        >
                      </li>
                      <li>
                        <a
                          class="pointer"
                          @click="deleteOrder(props.row.originalIndex)"
                          >Delete Order</a
                        >
                      </li>
                    </ul>
                  </div>
                </span>
                <span v-else-if="props.column.field === 'order_reference'">
                  <router-link
                    :to="{
                      name: 'fabric_order_update',
                      params: { order_id: props.row.id },
                    }"
                  >
                    {{ props.row.order_reference }}
                  </router-link>
                </span>
                <span v-else-if="props.column.field === 'delivery_date'">
                  <div v-if="props.row.delivery_date !== null">
                    {{ props.row.delivery_date }}
                  </div>
                  <div
                    class="future-delivery"
                    v-if="
                      props.row.delivery_date === null &&
                      props.row.expected_delivery_date !== null
                    "
                  >
                    {{ props.row.expected_delivery_date }}
                  </div>
                </span>
                <span v-else-if="props.column.field === 'sum_delivery_amount'">
                  <span v-if="props.row.delivery_amount !== '-'">
                    {{ ezy.comma(props.row.delivery_amount) }}
                    {{
                      props.row.delivery_amount !== "-" ? props.row.unit : ""
                    }}
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-minus-circle text-error"
                      aria-hidden="true"
                    ></i>
                  </span>
                </span>
                <span v-else-if="props.column.field === 'sum_order_amount'">
                  {{ ezy.comma(props.row.order_amount) }}
                  {{ props.row.order_amount !== "-" ? props.row.unit : "" }}
                </span>
                <span v-else-if="props.column.field === 'payment_date'">
                  <span
                    class="text-info"
                    title="Deposit has been paid"
                    v-if="props.row.payment_status === 'deposit_paid'"
                  >
                    {{ props.row.payment_date }}
                  </span>
                  <span
                    class="text-success"
                    title="Full payment has been made"
                    v-if="props.row.payment_status === 'fully_paid'"
                  >
                    {{ props.row.payment_date }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'average_price_unit'">
                  {{
                    ezy.comma(
                      priceWithSelectedCurrency(props.row, "average_price_unit")
                    )
                  }}
                  {{ showCurrency(props.row) }}
                </span>
                <span v-else-if="props.column.field === 'total_price'">
                  {{
                    ezy.comma(
                      priceWithSelectedCurrency(props.row, "total_price")
                    )
                  }}
                  {{ showCurrency(props.row) }}
                  <!-- <span v-if="props.row.delivery_amount !== '-'">{{ props.row.total_price_amount_delivered.toFixed(2) }} {{ props.row.currency }}</span>
                            <span v-if="props.row.delivery_amount === '-'">{{ props.row.total_price_amount_ordered.toFixed(2) }} {{ props.row.currency }}</span> -->
                </span>
                <span v-else-if="props.column.field === 'supplier'">
                  <span class="fa fa-external-link"></span>
                  <router-link
                    :to="{
                      name: 'fabric_suppliers_update',
                      params: { supplier_id: props.row.supplier.id },
                    }"
                  >
                    {{ props.row.supplier.name }}
                  </router-link>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TableHelper } from "@/pages/Tools/TableHelper.js";
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    VueGoodTable,
  },
  data() {
    return {
      defaultCurrency: null,
      searchTerm: "",
      isLoading: false,
      isReadOnlyUser: false,
      columns: [
        {
          label: "Order Ref",
          field: "order_reference",
          type: "number",
          tdClass: "text-left order-reference",
          thClass: "bg-primary order-reference text-left",
        },
        { label: "Supplier", field: "supplier", thClass: "bg-primary" },
        {
          label: "Order Creation Date",
          field: "order_creation_date",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
        },
        {
          label: "Invoice Date",
          field: "invoice_date",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
        },
        {
          label: "Payment Date",
          field: "payment_date",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
        {
          label: "Delivery Date",
          field: "delivery_date",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
        {
          label: "Fabric Count",
          field: "fabric_count",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
        {
          label: "Order Amount",
          field: "sum_order_amount",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
        {
          label: "Delivery Amount",
          field: "sum_delivery_amount",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
        {
          label: "Average Price/Unit",
          field: "average_price_unit",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
        {
          label: "Total Price",
          field: "total_price",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
        {
          label: "",
          field: "action_id",
          sortable: false,
          tdClass: "text-right",
          thClass: "bg-primary",
        },
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          {
            field: "fabric_orders.order_reference",
            type: "desc",
          },
        ],
        page: 1,
        perPage: 10,
      },
    };
  },

  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.helper = new TableHelper({
      parent: this,
      endpoint: "/v2/fabrics/orders",
      sort: {
        order_creation_date: "desc",
      },
    });
  },

  methods: {
    showCurrency(data) {
      if (this.defaultCurrency == null) {
        return data.currency;
      } else {
        return this.defaultCurrency;
      }
    },

    priceWithSelectedCurrency(data, column) {
      if (!data[column]) {
        data[column] = 0;
      }
      if (this.defaultCurrency == null) {
        return data[column].toFixed(2);
      } else if (this.defaultCurrency === "THB") {
        if (data.currency === "THB") {
          return data[column].toFixed(2);
        } else {
          return (data[column] * data.exchange_rate["thb"]).toFixed(2);
        }
      } else if (this.defaultCurrency === "USD") {
        if (data.currency === "USD") {
          return data[column].toFixed(2);
        } else {
          return (data[column] / data.exchange_rate["thb"]).toFixed(2);
        }
      } else if (this.defaultCurrency === "EUR") {
        let usd = 0;
        if (data.currency === "USD") {
          usd = data[column];
        } else {
          usd = data[column] / data.exchange_rate["thb"];
        }
        return (usd * data.exchange_rate["eur"]).toFixed(2);
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    searchOrder() {
      this.updateParams({
        page: 1,
        columnFilters: {
          order_reference: this.searchTerm,
        },
      });
      this.helper.reloadData();
      this.loadPageData();
    },

    /** Vue-Good-Tables Methods */

    onColumnFilter(params) {
      this.updateParams(params);
      this.helper.reloadData();
    },

    getCustomListingParams() {
      let listingParams = {};
      if (this.searchTerm.length > 0) {
        listingParams["filters"] = "fabric_suppliers.name";
        listingParams["search"] = this.searchTerm;
      }

      return listingParams;
    },

    async loadPageData() {
      try {
        let listingParams = {
          columns: "*",
          sort: "id:asc",
          page: this.serverParams.page,
          per_page: this.serverParams.perPage,
          filters: "",
          search: "",
        };

        listingParams = Object.assign(
          listingParams,
          this.getCustomListingParams()
        );

        let response = await axios({
          method: "get",
          url: "v2/fabrics/orders",
          params: listingParams,
        });

        let data = response.data.data;
        this.totalRecords = data.pagination.total_records;
        this.rows = data.collection;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to show orders, server error occurred.");
        }
      }
    },

    async deleteOrder(index) {
      var id = this.rows[index].id;
      if (await ezy.confirm("Are you sure to delete?", "Delete")) {
        try {
          let res = await axios.delete("v2/fabrics/orders/" + id);
          if (res) {
            this.rows.splice(index, 1);
            toastr.success("Successfully deleted!");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            Swal.fire("ERROR", error.response.data.errors.join(","), "error");
          }
        }
      }
    },
    checkDate(date) {
      var m = moment(date, "YYYY-MM-DD");
      if (m.isValid()) {
        return moment(date, "YYYY-MM-DD").format("DD-MMM-YYYY");
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
@import "~vue-good-table/dist/vue-good-table.css";
@import "~sweetalert2/dist/sweetalert2.min.css";

.form-control {
  height: 38px;
}

.search-input {
  width: 300px;
}

.input-group-addon {
  height: 38px !important;
}

.table td {
  vertical-align: middle !important;
}

.table tr {
  background: #09a599 !important;
  color: white !important;
}

.order-reference {
  width: 300px !important;
}

.future-delivery {
  background: #f00;
  color: white;
  padding: 5px;
}

.dropdown-menu {
  left: -128px;
}
</style>
